import { useMemo } from 'react';

import { useProducts } from '../../ProductSelect';
import { useInviteeListStateContext } from '../../InviteeList';
import { type InvitePeopleData } from '../../../types';

export const useInvitePeopleData = (): InvitePeopleData => {
	const { groups, users } = useInviteeListStateContext();
	const { selectedProducts, inviteCapabilities } = useProducts();
	const { userPickerOptions: inviteeListOptions } = useInviteeListStateContext();

	return useMemo(
		() => ({
			groups,
			inviteCapabilities,
			inviteeListOptions,
			selectedProducts,
			users,
		}),
		[groups, inviteCapabilities, inviteeListOptions, selectedProducts, users],
	);
};
